import type { FaireProductEntity } from "../../entity_types/product";

export const p_4a6htex92d: FaireProductEntity = {
  token: "p_4a6htex92d",
  type: "product",
  name: "Sermon",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/0372b2d0061f69a0daf02a950cad66be80fbe752d9b59e534b7d34540b33324b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d94bd79eddfe52430b623ad41e6e2abe5685d85e711e8a414edaf2e43f95bce2.png",
    "https://cdn.faire.com/fastly/0eb4d3e91861fa542fe7cf96a2dc2f8c672d52790e8d6a1b590c65ef7e470595.png"
  ],
  priceDollars: 79,
  description: "Sermon is our best-selling coffee blend for a reason. Fruit forward and full-bodied, the Sermon is characterized by playful, fresh blueberries and decadent cocoa.\n\n𝐑𝐨𝐚𝐬𝐭 𝐋𝐞𝐯𝐞𝐥\n\n• Coffee Details Country\nColombia, East Africa\n\n𝐓𝐚𝐬𝐭𝐢𝐧𝐠 𝐍𝐨𝐭𝐞𝐬\nBlueberry Pie, Cocoa, Candied Pecan\n\n𝐏𝐫𝐨𝐝𝐮𝐜𝐞𝐫\nVarious Producers\n\n𝐏𝐫𝐨𝐜𝐞𝐬𝐬\nWashed & Natural\n\n𝐄𝐥𝐞𝐯𝐚𝐭𝐢𝐨𝐧\n1,200 - 2,000 Meters\n\n𝐇𝐚𝐫𝐯𝐞𝐬𝐭\nOctober - March\n\n𝐁𝐫𝐞𝐰 𝐌𝐞𝐭𝐡𝐨𝐝\nFrench Press\n\n𝐁𝐫𝐞𝐰 𝐑𝐚𝐭𝐢𝐨\n1:16\n\n𝐁𝐫𝐞𝐰 𝐑𝐞𝐜𝐢𝐩𝐞\n• Coffee: 43 grams\n• Water: 700 grams\n• Brew Time: 4:00 minutes\n\n• Farmlevel Story\nFarmlevel\n\nThe Sermon has always been a new take on an old classic. A round body, bittersweet cocoa notes, and a berry sweetness are what we consistently strive for.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:34.504Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
